import {
  AlarmIcon,
  CameraIcon,
  Box as DarkBox,
  DoorIcon,
} from '@hivewatch/dark'

import { DeviceType } from '@/graphql/generated/schemas'

import { ConnectionI } from '../../types/types'
import {
  FLOOR_PLAN_ASSOCIATION_GLYPH_GEOMETRY,
  FloorPlanColorScheme,
  getAssociationVisualColors,
} from '../../utils/floorPlanVisuals'

interface DarkFloorPlanAssociationMarkerIProps {
  colorScheme: FloorPlanColorScheme
  connection: ConnectionI
  size?: number
}

export const DarkFloorPlanAssociationMarker = ({
  colorScheme,
  connection,
  size = 28,
}: DarkFloorPlanAssociationMarkerIProps) => {
  const colors = getAssociationVisualColors(connection, colorScheme)
  const glyphSize = size * FLOOR_PLAN_ASSOCIATION_GLYPH_GEOMETRY.sizeRatio
  const glyphTop = size * FLOOR_PLAN_ASSOCIATION_GLYPH_GEOMETRY.topRatio

  return (
    <DarkBox
      bg={colors.background}
      borderRadius='full'
      data-association-state={colors.state}
      data-testid='DarkFloorPlanAssociationMarker'
      flexShrink={0}
      height={`${size}px`}
      position='relative'
      width={`${size}px`}
    >
      <DarkBox
        left={`${
          size * FLOOR_PLAN_ASSOCIATION_GLYPH_GEOMETRY.cameraLeftRatio
        }px`}
        position='absolute'
        top={`${glyphTop}px`}
      >
        <CameraIcon color={colors.glyph} size={glyphSize} />
      </DarkBox>
      <DarkBox
        left={`${
          size * FLOOR_PLAN_ASSOCIATION_GLYPH_GEOMETRY.deviceLeftRatio
        }px`}
        position='absolute'
        top={`${glyphTop}px`}
      >
        {connection.deviceType === DeviceType.Alarm ? (
          <AlarmIcon color={colors.glyph} size={glyphSize} />
        ) : (
          <DoorIcon color={colors.glyph} size={glyphSize} />
        )}
      </DarkBox>
    </DarkBox>
  )
}
